export enum BaseApplication {
  growth = 'Growth',
  medical = 'Medical',
  business = 'Business',
}

export type BaseApplicationTagType = 'medical' | 'business' | undefined;

// for now these remain undefined, because every qualification should be available in every other;
// the api currently awaits BaseApplicationTagType for the tags
export const businessTag: BaseApplicationTagType = 'business';
export const medicalTag: BaseApplicationTagType = 'medical';

export enum BaseApplicationLogo {
  growth = 'assets-global/images/stazzle-growth.svg',
  medical = 'assets-global/images/stazzle-medical.svg',
  medicalSmall = 'assets-global/images/stazzle-medical-logo-small.svg',
  business = 'assets-global/images/stazzle-business.svg',
  felten = 'assets-global/images/felten/felten-customer-portal.svg',
  feltenSmall = 'assets-global/images/felten-customer-portal-logo-small.svg',
  systemPage = 'assets-global/images/stazzle-logo-dark-blue.svg',
  systemPageSmall = 'assets-global/images/stazzle-logo-small-dark-blue.svg',
}

export enum BaseUnbrandedWrapperApplicationLogo {
  growth = 'assets-global/images/stazzle-logo-dark-blue.svg',
  medical = 'assets-global/images/stazzle-logo-dark-blue.svg',
  business = 'assets-global/images/stazzle-logo-dark-blue.svg',
  felten = 'assets-global/images/felten/felten-customer-portal.svg',
}
